export const DIALOG_ERR_GENERIC_TITLE = 'ERR_GENERIC_TITLE';

export const DIALOG_ERR_GENERIC_BODY = 'ERR_GENERIC_BODY';

export const DIALOG_TRY_AGAIN_BUTTON = 'TRY_AGAIN_BUTTON';
export const DIALOG_CANCEL_BUTTON = 'CANCEL_BUTTON';
